// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import React from "react";

const styles = {
  grid: {
    margin: "0 !important",
    width: "unset",
    position: "relative",
    overflow: "auto",
    minHeight: "30px",
    padding: "5px 5px"
  }
};

const useStyles = makeStyles(styles);

export default function GridContainer(props) {
  const classes = useStyles();
  const { children, ...rest } = props;
  return (
    <Grid container {...rest} className={classes.grid}>
      {children}
    </Grid>
  );
}

GridContainer.propTypes = {
  children: PropTypes.node
};
